(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    (function () {
    document.addEventListener('click', function (e) {
      var swatch = e.target.closest('.card__swatch');
      if (!swatch) return;

      e.preventDefault();
      e.stopPropagation();

      var imgUrl = swatch.getAttribute('data-image');
      var cardId = swatch.getAttribute('data-card-id');
      var cardImg = document.querySelector('[data-card-img="' + cardId + '"]');

      if (cardImg && imgUrl) cardImg.src = imgUrl;

      var siblings = swatch.closest('.card__color-swatches').querySelectorAll('.card__swatch');
      siblings.forEach(function (s) { s.classList.remove('card__swatch--active'); });
      swatch.classList.add('card__swatch--active');
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price-facet"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('price-slider')) {
    class PriceSlider extends HTMLElement {
      connectedCallback() {
        this.fill = this.querySelector('[data-price-fill]');
        this.rangeMin = this.querySelector('[data-price-range-min]');
        this.rangeMax = this.querySelector('[data-price-range-max]');
        this.textMin = this.querySelector('[data-price-text-min]');
        this.textMax = this.querySelector('[data-price-text-max]');
        this.track = this.querySelector('[data-price-track]');

        if (!this.fill || !this.rangeMin || !this.rangeMax || !this.textMin || !this.textMax) return;

        this.sliderMax = parseFloat(this.rangeMin.max) || 1;

        this.onRangeMinInput = this.onRangeMinInput.bind(this);
        this.onRangeMaxInput = this.onRangeMaxInput.bind(this);
        this.onRangeMinCommit = this.onRangeMinCommit.bind(this);
        this.onRangeMaxCommit = this.onRangeMaxCommit.bind(this);
        this.onTextMinInput = this.onTextMinInput.bind(this);
        this.onTextMaxInput = this.onTextMaxInput.bind(this);
        this.onTrackPointerDown = this.onTrackPointerDown.bind(this);
        this.onTrackPointerUp = this.onTrackPointerUp.bind(this);

        // `input` fires continuously while dragging -> visual only, never
        // let this bubble up into Dawn's form or it'll fire an AJAX
        // request on every single drag tick and cause a race condition.
        this.rangeMin.addEventListener('input', this.onRangeMinInput);
        this.rangeMax.addEventListener('input', this.onRangeMaxInput);

        // `change` fires exactly once, when the handle is released ->
        // THIS is when we actually tell Dawn's form the value changed.
        this.rangeMin.addEventListener('change', this.onRangeMinCommit);
        this.rangeMax.addEventListener('change', this.onRangeMaxCommit);

        this.textMin.addEventListener('input', this.onTextMinInput);
        this.textMax.addEventListener('input', this.onTextMaxInput);

        // Bring whichever handle the user grabs to the front, so overlapping
        // thumbs (both near 0, or both near max) don't block each other.
        this.rangeMin.addEventListener('pointerdown', (e) => this.onThumbPointerDown(e, this.rangeMin));
        this.rangeMax.addEventListener('pointerdown', (e) => this.onThumbPointerDown(e, this.rangeMax));

        // Click/tap anywhere on the bar jumps the nearest handle straight there.
        if (this.track) {
          this.track.addEventListener('pointerdown', this.onTrackPointerDown);
          this.track.addEventListener('pointerup', this.onTrackPointerUp);
        }

        this.renderFill();
      }

      pct(value) {
        return Math.min(Math.max((value / this.sliderMax) * 100, 0), 100);
      }

      renderFill() {
        var minVal = parseFloat(this.rangeMin.value) || 0;
        var maxVal = parseFloat(this.rangeMax.value) || 0;
        var left = this.pct(minVal);
        var right = this.pct(maxVal);
        this.fill.style.left = left + '%';
        this.fill.style.width = Math.max(right - left, 0) + '%';
      }

      bringToFront(target) {
        this.rangeMin.style.zIndex = target === this.rangeMin ? 4 : 2;
        this.rangeMax.style.zIndex = target === this.rangeMax ? 4 : 2;
      }

      // Explicitly locks all subsequent pointer events (move/up) to whichever
      // thumb the user grabbed, even if the cursor later crosses over the
      // other overlapping input. This is what stops fast/edge drags from
      // "dropping" mid-gesture.
      onThumbPointerDown(event, input) {
        this.bringToFront(input);

        // Hard-disable the OTHER thumb for the duration of this drag so it
        // is physically impossible for the browser to grab both handles at
        // once — this is what fixes the "both dots collapse together" bug.
        const other = input === this.rangeMin ? this.rangeMax : this.rangeMin;
        other.classList.add('price-slider-input--inert');

        const releaseInert = () => {
          other.classList.remove('price-slider-input--inert');
          input.removeEventListener('pointerup', releaseInert);
          input.removeEventListener('pointercancel', releaseInert);
          window.removeEventListener('pointerup', releaseInert);
        };
        input.addEventListener('pointerup', releaseInert);
        input.addEventListener('pointercancel', releaseInert);
        // Safety net: if pointerup fires outside the input (e.g. user drags
        // off-screen and releases), still clean up.
        window.addEventListener('pointerup', releaseInert, { once: true });

        if (typeof input.setPointerCapture === 'function') {
          try {
            input.setPointerCapture(event.pointerId);
          } catch (e) {
            /* no-op: unsupported browsers just fall back to default behavior */
          }
        }
      }

      // ---- visual-only handlers (every drag tick) ----

      onRangeMinInput(event) {
        // Never let this reach Dawn's form-level listener - it fires on
        // every pixel of the drag and would trigger a flood of AJAX
        // requests that race each other. Visual update only.
        event.stopPropagation();

        // Clamp ONLY this handle — never push the other handle's value.
        // This is what stops the "swap glitch" on fast drags past the
        // other thumb: min simply sticks at max's current value instead
        // of both handles jumping.
        var minVal = parseFloat(this.rangeMin.value) || 0;
        var maxVal = parseFloat(this.rangeMax.value) || 0;
        if (minVal > maxVal) {
          this.rangeMin.value = maxVal;
        }
        minVal = parseFloat(this.rangeMin.value) || 0;
        this.textMin.value = minVal <= 0 ? '' : this.rangeMin.value;
        this.renderFill();
      }

      onRangeMaxInput(event) {
        event.stopPropagation();

        var minVal = parseFloat(this.rangeMin.value) || 0;
        var maxVal = parseFloat(this.rangeMax.value) || 0;
        if (maxVal < minVal) {
          this.rangeMax.value = minVal;
        }
        maxVal = parseFloat(this.rangeMax.value) || 0;
        // At the right end: leave To empty so Shopify applies no max bound.
        this.textMax.value = maxVal >= this.sliderMax ? '' : this.rangeMax.value;
        this.renderFill();
      }

      // ---- commit handlers (fire once, on release) ----
      // This is what actually notifies Dawn's FacetFiltersForm, by firing
      // real events on the named text inputs it already knows how to read
      // - exactly the same as if the user had typed the value in.

      onRangeMinCommit(event) {
        event.stopPropagation();
        this.commitTextField(this.textMin);
      }

      onRangeMaxCommit(event) {
        event.stopPropagation();
        this.commitTextField(this.textMax);
      }

      commitTextField(textField) {
        // Dispatch real, bubbling events so Dawn's form (which listens for
        // input/change on its named fields) picks up exactly one clean
        // update with the final, correct value.
        textField.dispatchEvent(new Event('input', { bubbles: true }));
        textField.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // ---- typing in the boxed Rs. fields (already worked fine) ----

      onTextMinInput() {
        var val = parseFloat(this.textMin.value.replace(',', '.'));
        if (!isNaN(val)) {
          this.rangeMin.value = Math.min(Math.max(val, 0), this.sliderMax);
          this.renderFill();
        }
      }

      onTextMaxInput() {
        var val = parseFloat(this.textMax.value.replace(',', '.'));
        if (!isNaN(val)) {
          this.rangeMax.value = Math.min(Math.max(val, 0), this.sliderMax);
          this.renderFill();
        }
      }

      // ---- click/tap directly on the track ----

      onTrackPointerDown(event) {
        // Ignore pointerdowns that actually originated on a thumb — the
        // native drag behavior of that input takes over in that case.
        if (event.target === this.rangeMin || event.target === this.rangeMax) return;

        var rect = this.track.getBoundingClientRect();
        var ratio = Math.min(Math.max((event.clientX - rect.left) / rect.width, 0), 1);
        var value = Math.round(ratio * this.sliderMax);

        var minVal = parseFloat(this.rangeMin.value) || 0;
        var maxVal = parseFloat(this.rangeMax.value) || 0;

        // Move whichever handle sits closer to the click point.
        if (Math.abs(value - minVal) <= Math.abs(value - maxVal)) {
          this.rangeMin.value = value;
          this.bringToFront(this.rangeMin);
          this._trackTarget = this.rangeMin;
          this.onRangeMinInput(event);
        } else {
          this.rangeMax.value = value;
          this.bringToFront(this.rangeMax);
          this._trackTarget = this.rangeMax;
          this.onRangeMaxInput(event);
        }
      }

      onTrackPointerUp() {
        // A tap-on-track is a single, complete gesture — it never fires a
        // native `change` on the range input (we set .value directly, not
        // via a real drag), so commit here to notify Dawn's form once.
        if (this._trackTarget === this.rangeMin) {
          this.commitTextField(this.textMin);
        } else if (this._trackTarget === this.rangeMax) {
          this.commitTextField(this.textMax);
        }
        this._trackTarget = null;
      }
    }

    customElements.define('price-slider', PriceSlider);
  }
  } catch(e) { console.error(e); }
})();

})();
